import { render, staticRenderFns } from "./Otherdocs.vue?vue&type=template&id=2c0bbd70&"
import script from "./Otherdocs.vue?vue&type=script&lang=js&"
export * from "./Otherdocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports